interface WineStyleBarProps {
  label: string;
  value: number;   // 1–5
  lowLabel?: string;
  highLabel?: string;
}

export default function WineStyleBar({
  label,
  value,
  lowLabel,
  highLabel,
}: WineStyleBarProps) {
  const pct = Math.max(0, Math.min(5, value)) / 5;

  return (
    <div className="style-bar">
      <span className="style-bar-label">{label}</span>
      <div className="style-bar-track">
        <div className="style-bar-fill" style={{ width: `${pct * 100}%` }} />
      </div>
      {(lowLabel || highLabel) && (
        <div className="style-bar-ends">
          <span>{lowLabel}</span>
          <span>{highLabel}</span>
        </div>
      )}
    </div>
  );
}
